import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { commEmptyStateSx } from './communicationsStyles';

interface Props {
  icon: React.ReactNode;
  heading: string;
  description?: string;
  ctaLabel?: string;
  onCta?: () => void;
  /** Extra sx overrides on the wrapper box */
  sx?: object;
}

const CommEmptyState: React.FC<Props> = ({
  icon,
  heading,
  description,
  ctaLabel,
  onCta,
  sx,
}) => (
  <Box sx={{ ...commEmptyStateSx, ...sx }}>
    <Box sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }}>{icon}</Box>
    <Typography variant="h6" color="text.secondary" gutterBottom>
      {heading}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.disabled" sx={{ mb: 2, maxWidth: 480, mx: 'auto' }}>
        {description}
      </Typography>
    )}
    {ctaLabel && onCta && (
      <Button variant="outlined" startIcon={<AddIcon />} onClick={onCta}>
        {ctaLabel}
      </Button>
    )}
  </Box>
);

export default CommEmptyState;
